import { Locale } from '@buildium/angularjs-core/dist/localization/services/locale';

export function BdLocale($window) {
    // bdApplicationState is currently only set after the user has been authenticated so we need a default for public pages
    const timeZone = $window.bdApplicationState
        ? $window.bdApplicationState.settings.SubscriberSettingsInfo.TzInfoName
        : 'America/New_York';
    return Locale($window, timeZone);
}
BdLocale.$inject = ['$window'];
